<template>
  <div class="container mx-auto px-4 py-6">
    <h2 class="mb-6 text-2xl font-bold text-center md:text-left">Tus artículos</h2>

    <div class="overflow-x-auto">
      <table class="w-full bg-gray-200 rounded-lg shadow-sm min-w-[640px]">
        <thead>
          <tr class="text-white bg-yellow-500">
            <th class="p-3 text-sm font-semibold tracking-wide text-left">Imagen</th>
            <th class="p-3 text-sm font-semibold tracking-wide text-left">Producto</th>
            <th class="p-3 text-sm font-semibold tracking-wide text-center">Disponible</th>
            <th class="p-3 text-sm font-semibold tracking-wide text-center">P/U unitario</th>
            <th class="p-3 text-sm font-semibold tracking-wide text-center">Cantidad mínima</th>
            <th class="p-3 text-sm font-semibold tracking-wide text-center">Cantidad</th>
            <th class="p-3 text-sm font-semibold tracking-wide text-center">Subtotal</th>
            <th class="p-3 text-sm font-semibold tracking-wide text-center">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-300">
          <tr v-for="cart in carts.data" :key="cart.id" class="hover:bg-gray-100 transition-colors duration-200">
            <td class="p-3"><img :src="cart.product.photo ? `/storage/${cart.product.photo}` : 'https://coffective.com/wp-content/uploads/2018/06/default-featured-image.png.jpg'" alt="Imagen del producto" class="w-16 h-16 object-cover rounded-md" /></td>
            <td class="p-3 font-medium">{{ cart.product.name }}</td>
            <td class="p-3 text-center">{{ cart.quantity }}</td>
            <td class="p-3 text-center">${{ cart.price.toFixed(2) }}</td>
            <td class="p-3 text-center">{{ cart.product.min_quantity }}</td>
            <td class="p-3">
              <input type="number" disabled v-model="cart.quantity" class="px-3 py-2 w-full text-center rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-500" />
            </td>
            <td class="p-3 text-center font-semibold">${{ (cart.quantity * cart.price).toFixed(2) }}</td>
            <td class="p-3 text-center">
              <button @click="removeCart(cart.id)" class="px-4 py-2 text-white font-bold bg-red-500 hover:bg-red-700 rounded">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex flex-col justify-between mt-4 md:flex-row">
      <a href="/" class="mt-2 px-4 py-2 text-white font-bold bg-blue-500 hover:bg-blue-700 rounded md:mt-0">Continuar compra</a>
      <button @click="cleanCart" class="px-4 py-2 text-white font-bold bg-red-500 hover:bg-red-700 rounded">Limpiar carrito</button>
    </div>

    <div class="flex flex-col gap-4 mt-4 md:flex-row rounded">
      <div class="p-4 w-full md:w-1/2 bg-gray-200 rounded">
        <h3 class="mb-2 text-lg font-bold">Usar cupón de descuento</h3>
        <input type="text" placeholder="Ingrese el cupón de descuento" class="px-2 py-1 w-full rounded" />
        <button class="mt-2 px-4 py-2 text-white font-bold bg-green-500 hover:bg-green-700 rounded">Aplicar cupón</button>
      </div>

      <div class="p-4 w-full bg-gray-200 md:w-1/2 px-5 rounded">
        <h3 class="mb-2 text-lg font-bold">Total en productos</h3>
        <p>{{ total_products }}x productos</p>
        <p class="text-xl font-bold">Total: ${{ total.toFixed(2) }}</p>
        <button @click="generateOrder" class="mt-2 px-4 py-2 w-full text-white font-bold bg-yellow-500 hover:bg-yellow-700 rounded">Realizar pedido</button>
      </div>
    </div>
  </div>
</template>

<script>
import WebLayout from '../../Layouts/WebLayout.vue'
export default {
  layout: WebLayout,
  props: {
    carts: Object,
    total_products: Number,
    total: Number,
    client: Object
  },
  data() {
    return {
      form: this.$inertia.form({
        client: {
          name: this.client.name,
          identification: this.client.identification,
          typeClient: this.client.typeClient
        },
        products: [],
        comentary: 'Compra desde la web',
        isCredit: false,
        quick: true,
        referencePay: 'N/A'
      }),
    }
  },
  methods: {
    cleanCart() {
      this.$inertia.delete('/web/cart')
    },
    generateOrder() {
      let products = [];

      this.carts.data.forEach(element => {
        products.push({
            id: element.product.id,
            quantity: element.quantity,
            quick: false,
            price: element.price
          })
        })

      this.form.products = products;
      this.form.post('/web/orders')
    },
    removeCart(id) {
      this.$inertia.delete(`/web/cart/${id}`)
    }
  },
}
</script>
